import { decorateUrlForRedirect } from 'services/store-metrics/init';

export function redirectTo(url: string): void {
  window.location.href = decorateUrlForRedirect(url);
}
